/* eslint-disable react/no-array-index-key */
import React from 'react';
import { checkBreakPoint, checkSetPoint } from '../../../../utils/common';

const TennisMatchPointsSequence = ({
  gameHistory, hasWinningPlayer,
}) => gameHistory.pointsSequence.map((pointScore, idx) => {
  const isBreakPoint = checkBreakPoint(pointScore, gameHistory.servingPlayer);
  const isSetPoint = checkSetPoint(pointScore, gameHistory);
  const addComma = idx !== gameHistory.pointsSequence.length - 1;
  const isMatchPoint = isSetPoint && hasWinningPlayer;
  return (
    <React.Fragment key={`${pointScore}-${idx}`}>
      <span>{`${pointScore}`}</span>
      {isBreakPoint && (
        <span
          className="tennisDetails__label tennisDetails__label--breakPoint"
        >
          Bp
        </span>
      )}
      {isMatchPoint && (
        <span
          className="tennisDetails__label tennisDetails__label--matchPoint"
        >
          mp
        </span>
      )}

      {!isMatchPoint && isSetPoint
        && (
          <span
            className="tennisDetails__label tennisDetails__label--setPoint"
          >
            sp
          </span>
        )}
      {addComma
        && <span>, </span>}
    </React.Fragment>
  );
});
export default TennisMatchPointsSequence;

